import $ from 'jquery';

$(function () {
    const $toggle = $('[data-category-filter-toggle]');
    const $body = $('body');
    const bodyClass = 'body_categoryfilter_visible';

    $toggle.click(function () {
        $body.toggleClass(bodyClass);
    })
});
